<template>
  <section class="bgcc min-h-screen pt-20">
    <div class="min-h-screen from-cyan-50 via-blue-50 to-teal-50">
        <!-- Header Section -->
        <div class="bg-gradient-to-r from-teal-600 to-cyan-600 text-white py-12 shadow-lg">
            <div class="container mx-auto px-4">
            <div class="max-w-4xl mx-auto text-center">
                <!-- Breadcrumb Navigation -->
                <nav class="flex items-center mb-4 text-sm justify-center">
                    <router-link
                    :to="{ name: 'FloodReliefMission' }"
                    class="flex items-center text-cyan-100 hover:text-white transition-colors"
                    >
                    <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                    </svg>
                        กลับหน้าโครงการจิตอาสา
                    </router-link>
                    <svg class="w-4 h-4 mx-2 text-cyan-100" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                    </svg>
                    <span class="text-white font-semibold">ตรวจสอบสถานะ</span>
                </nav>
                <p class="text-sm font-semibold tracking-widest uppercase text-white/80">โครงการจิตอาสา · Flood Relief Mission</p>
                <h1 class="mt-3 text-3xl font-bold md:text-4xl">ตรวจสอบสถานะคำขอเบิกค่าเชื้อเพลิง</h1>
                <!-- <p class="mt-3 text-white/90">
                    ดูความคืบหน้าคำขอของคุณแบบเรียลไทม์ ทั้งสถานะอนุมัติ ยอดเงิน และหลักฐานที่แนบไว้
                </p> -->
                <!-- <div class="flex flex-wrap gap-3 mt-6 text-sm font-semibold">
                    <span class="px-3 py-1 rounded-full bg-white/15">เรียงจากคำขอล่าสุด</span>
                    <span class="px-3 py-1 rounded-full bg-white/15">กรองตามสถานะ</span>
                    <span class="px-3 py-1 rounded-full bg-white/15">อัปเดตทุกครั้งที่มีการเปลี่ยนแปลง</span>
                </div> -->
            </div>
            </div>
        </div>

        <!-- Main Content Section -->
        <!-- <div class="p-6 space-y-6 bg-white border border-gray-100 shadow-2xl rounded-3xl md:p-8"> -->
        <div class="container mx-auto px-4 py-8">
            <div class="flex flex-wrap items-center justify-between gap-4 mb-6">
                <div>
                    <h2 class="text-2xl font-semibold text-gray-900">รายการคำขอของฉัน</h2>
                    <p class="text-sm text-gray-500">เรียงตามวันที่ส่งคำขอ (ล่าสุดก่อน)</p>
                </div>
                <div class="flex flex-wrap gap-2">
                    <button
                    v-for="option in statusOptions"
                    :key="option.key"
                    type="button"
                    class="px-4 py-2 text-sm font-semibold transition border rounded-full"
                    :class="[
                        activeStatus === option.key
                        ? 'bg-teal-600 text-white border-teal-600 shadow'
                        : 'text-gray-600 border-gray-200 hover:border-teal-400'
                    ]"
                    @click="changeStatusFilter(option.key)"
                    >
                    {{ option.label }}
                    </button>
                </div>
            </div>

            <div v-if="error" class="p-4 text-sm text-red-700 bg-red-50 border border-red-100 rounded-2xl">
                {{ error }}
                <button type="button" class="inline-flex items-center mt-2 text-red-600" @click="fetchRequests()">
                    ลองอีกครั้ง
                    <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v6h6M20 20v-6h-6M5 19A9 9 0 0119 5" />
                    </svg>
                </button>
            </div>

            <div v-else>
                <div v-if="loading" class="space-y-4">
                    <div v-for="n in 3" :key="n" class="p-6 border rounded-3xl bg-gray-50 border-gray-100 animate-pulse h-36"></div>
                </div>

            <div v-else>
                <div v-if="requests.length === 0" class="p-6 text-center border border-gray-100 rounded-3xl bg-gray-50">
                    <h3 class="text-lg font-semibold text-gray-800">ยังไม่มีคำขอในสถานะนี้</h3>
                    <p class="mt-2 text-sm text-gray-500">เริ่มต้นส่งคำขอใหม่จากปุ่ม "แบบฟอร์มขอเบิกค่าเชื้อเพลิง" บนหน้าหลัก</p>
                </div>

                <div v-else class="space-y-4">
                    <article
                        v-for="request in requests"
                        :key="request.id"
                        class="relative p-6 transition border rounded-3xl bg-white shadow-sm"
                        :class="getCardBorderClass(request)"
                    >
                        <div class="flex flex-wrap items-start justify-between gap-4">
                        <div>
                            <p class="text-sm font-semibold text-gray-500">{{ request.organization_name || 'ไม่ระบุชื่อองค์กร' }}</p>
                            <h3 class="mt-1 text-2xl font-bold text-gray-900">฿{{ formatCurrency(request.total_amount) }}</h3>
                            <p class="mt-1 text-sm text-gray-500">ส่งคำขอวันที่ {{ formatDateTime(request.created_at) }}</p>
                        </div>
                        <span
                            class="inline-flex items-center gap-2 px-3 py-1 text-sm font-semibold rounded-full border"
                            :class="getStatusChipClass(request)"
                        >
                            <span class="w-2 h-2 rounded-full" :class="getStatusDotClass(request)"></span>
                            {{ getStatusLabel(request) }}
                        </span>
                        </div>

                        <div class="mt-1 grid gap-1 md:grid-cols-2">
                        <div
                            v-for="row in buildInfoRows(request)"
                            :key="row.key"
                            class="info-card"
                        >
                            <p class="text-xs font-semibold tracking-wide text-gray-500 uppercase">{{ row.label }}</p>
                            <p
                            class="mt-1 text-base text-gray-900"
                            :class="row.valueClass || ''"
                            >
                            {{ row.value }}
                            </p>
                        </div>
                        </div>

                        <!-- <div class="grid gap-4 mt-6 md:grid-cols-3">
                        <div>
                            <p class="text-xs font-semibold tracking-wide text-gray-500 uppercase">วันที่ลงพื้นที่</p>
                            <p class="mt-1 text-base font-semibold text-gray-900">{{ formatDate(request.field_date) }}</p>
                        </div>
                        <div>
                            <p class="text-xs font-semibold tracking-wide text-gray-500 uppercase">จำนวนพาหนะ</p>
                            <p class="mt-1 text-base font-semibold text-gray-900">{{ request.vehicle_count }} คัน</p>
                        </div>
                        <div>
                            <p class="text-xs font-semibold tracking-wide text-gray-500 uppercase">ประเภทพาหนะ</p>
                            <p class="mt-1 text-base font-semibold text-gray-900">{{ request.fuel_for }}</p>
                        </div>
                        </div> -->

                        <div class="mt-6">
                        <p class="text-xs font-semibold tracking-wide text-gray-500 uppercase">จังหวัดที่ลงพื้นที่</p>
                        <div class="flex flex-wrap gap-2 mt-2">
                            <span
                            v-for="province in parseProvinceList(request.field_provinces)"
                            :key="province"
                            class="province-badge"
                            >
                            {{ province }}
                            </span>
                            <span v-if="parseProvinceList(request.field_provinces).length === 0" class="text-sm text-gray-500">
                            ไม่ได้ระบุ
                            </span>
                        </div>
                        </div>

                        <div class="mt-4 flex justify-end" v-if="[1, 5].includes(request.status)">
                            <router-link
                                :to="{ name: 'FloodReliefMissionEdit', params: { encryptedId: request.encrypted_id } }"
                                class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-yellow-500 rounded-lg hover:bg-yellow-600 focus:ring-4 focus:ring-yellow-300 transition-colors"
                            >
                                <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                </svg>
                                แก้ไขข้อมูล
                            </router-link>
                        </div>
                    </article>

                    <div v-if="hasPagination" class="flex flex-wrap items-center justify-between gap-4 pt-4 border-t border-gray-100">
                        <p class="text-sm text-gray-500">
                        หน้า {{ pagination.current_page }} / {{ pagination.last_page }} · ทั้งหมด {{ pagination.total }} รายการ
                        </p>
                        <div class="flex gap-3">
                        <button
                            type="button"
                            class="px-4 py-2 text-sm font-semibold border rounded-full"
                            :class="pagination.prev_page_url ? 'text-gray-700 border-gray-300 hover:border-teal-400' : 'text-gray-400 border-gray-200 cursor-not-allowed'"
                            :disabled="!pagination.prev_page_url"
                            @click="changePage(pagination.current_page - 1)"
                        >
                            ก่อนหน้า
                        </button>
                        <button
                            type="button"
                            class="px-4 py-2 text-sm font-semibold border rounded-full"
                            :class="pagination.next_page_url ? 'text-gray-700 border-gray-300 hover:border-teal-400' : 'text-gray-400 border-gray-200 cursor-not-allowed'"
                            :disabled="!pagination.next_page_url"
                            @click="changePage(pagination.current_page + 1)"
                        >
                            ถัดไป
                        </button>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
import FloodReliefMissionService from '@/services/FloodReliefMissionService'

const STATUS_CODE_TO_KEY = {
  1: 'pending',
  2: 'approved',
  3: 'rejected',
  4: 'paid',
  5: 'evidence_needed'
}

const STATUS_PRESENTATION = {
  pending: {
    label: 'รอตรวจสอบ',
    chipClass: 'status-chip-pending',
    dotClass: 'status-dot-pending',
    borderClass: 'status-border-pending'
  },
  approved: {
    label: 'อนุมัติแล้ว',
    chipClass: 'status-chip-approved',
    dotClass: 'status-dot-approved',
    borderClass: 'status-border-approved'
  },
  rejected: {
    label: 'ไม่ผ่าน',
    chipClass: 'status-chip-rejected',
    dotClass: 'status-dot-rejected',
    borderClass: 'status-border-rejected'
  },
  paid: {
    label: 'โอนเงินแล้ว',
    chipClass: 'status-chip-paid',
    dotClass: 'status-dot-paid',
    borderClass: 'status-border-paid'
  },
  evidence_needed: {
    label: 'ขอหลักฐานเพิ่ม',
    chipClass: 'status-chip-evidence',
    dotClass: 'status-dot-evidence',
    borderClass: 'status-border-evidence'
  }
}

const currencyFormatter = new Intl.NumberFormat('th-TH', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})

const dateFormatter = new Intl.DateTimeFormat('th-TH', { dateStyle: 'medium' })
const dateTimeFormatter = new Intl.DateTimeFormat('th-TH', { dateStyle: 'medium', timeStyle: 'short' })

export default {
  name: 'FloodReliefMissionStatus',
  data() {
    return {
      loading: false,
      error: null,
      requests: [],
      pagination: null,
      activeStatus: 'all',
      statusOptions: [
        { key: 'all', label: 'ทั้งหมด' },
        { key: 'pending', label: 'รอตรวจสอบ' },
        { key: 'approved', label: 'อนุมัติแล้ว' },
        { key: 'paid', label: 'โอนเงินแล้ว' },
        { key: 'evidence_needed', label: 'ขอหลักฐานเพิ่ม' },
        { key: 'rejected', label: 'ไม่ผ่าน' }
      ]
    }
  },
  computed: {
    hasPagination() {
      return this.pagination && this.pagination.last_page && this.pagination.last_page > 1
    }
  },
  mounted() {
    //scroll to top on mount
    window.scrollTo(0, 0)
    localStorage.setItem('lastVisit', 'FloodReliefMissionStatus')
    this.fetchRequests()
  },
  methods: {
    async fetchRequests(page = 1) {
      this.loading = true
      this.error = null
      this.$Progress.start()

      const params = { page }
      if (this.activeStatus !== 'all') {
        params.status = this.activeStatus
      }

      try {
        const response = await FloodReliefMissionService.getMyRequests(params)
        const payload = response && response.data && response.data.data ? response.data.data : {}
        this.pagination = payload
        this.requests = payload.data || []
        this.$Progress.finish()
      } catch (err) {
        this.error = err && err.response && err.response.data && err.response.data.message
          ? err.response.data.message
          : 'ไม่สามารถโหลดรายการคำขอได้'
        this.$Progress.fail()
      } finally {
        this.loading = false
        this.$Progress.finish()
      }
    },
    changeStatusFilter(statusKey) {
      if (this.activeStatus === statusKey) {
        return
      }
      this.activeStatus = statusKey
      this.fetchRequests(1)
    },
    changePage(targetPage) {
      if (!this.pagination || targetPage < 1 || targetPage > this.pagination.last_page) {
        return
      }
      this.fetchRequests(targetPage)
    },
    getStatusKey(request) {
      return STATUS_CODE_TO_KEY[request.status] || 'pending'
    },
    getStatusConfig(request) {
      const key = this.getStatusKey(request)
      return STATUS_PRESENTATION[key] || STATUS_PRESENTATION.pending
    },
    getStatusLabel(request) {
      return this.getStatusConfig(request).label
    },
    getStatusChipClass(request) {
      return this.getStatusConfig(request).chipClass
    },
    getStatusDotClass(request) {
      return this.getStatusConfig(request).dotClass
    },
    getCardBorderClass(request) {
      return this.getStatusConfig(request).borderClass
    },
    getRequestCode(request) {
      return request.request_number || request.request_code || '-'
    },
    parseProvinceList(value) {
      if (Array.isArray(value)) {
        return value.filter(Boolean)
      }
      if (typeof value === 'string') {
        try {
          const parsed = JSON.parse(value)
          return Array.isArray(parsed) ? parsed.filter(Boolean) : []
        } catch (e) {
          return []
        }
      }
      return []
    },
    formatCurrency(value) {
      return currencyFormatter.format(value || 0)
    },
    formatDate(dateStr) {
      if (!dateStr) {
        return '-'
      }
      const date = new Date(dateStr)
      return dateFormatter.format(date)
    },
    formatDateTime(dateStr) {
      if (!dateStr) {
        return '-'
      }
      const date = new Date(dateStr)
      return dateTimeFormatter.format(date)
    },
    buildInfoRows(request) {
      return [
        {
          key: 'request_number',
          label: 'เลขที่คำขอ',
          value: this.getRequestCode(request)
        },
        {
          key: 'coordinator_name',
          label: 'ผู้ประสานงาน',
          value: request.coordinator_name || '-'
        },
        {
          key: 'coordinator_phone',
          label: 'เบอร์ติดต่อผู้ประสานงาน',
          value: this.formatPhoneNumber(request.coordinator_phone)
        },
        {
          key: 'organization',
          label: 'ชื่อองค์กร/กลุ่ม',
          value: request.organization_name || '-'
        },
        {
          key: 'admin_notes',
          label: 'คำอธิบายการอนุมัติ',
          value: this.getAdminNotes(request),
          valueClass: 'text-gray-700 whitespace-pre-line'
        },
        {
          key: 'approved_amount',
          label: 'ยอดเงิน',
          value: `฿${this.formatCurrency(this.getApprovedAmount(request))}`
        }
      ]
    },
    formatPhoneNumber(value) {
      if (!value) {
        return '-'
      }
      const digits = value.replace(/[^0-9]/g, '')
      if (digits.length <= 3) {
        return digits
      }
      if (digits.length <= 6) {
        return `${digits.slice(0, 3)}-${digits.slice(3)}`
      }
      return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`
    },
    getAdminNotes(request) {
      return request.admin_notes && request.admin_notes.trim() !== ''
        ? request.admin_notes
        : '-'
    },
    getApprovedAmount(request) {
      if (request.approved_amount !== undefined && request.approved_amount !== null) {
        return Number(request.approved_amount)
      }
      return Number(request.total_amount) || 0
    }
  }
}
</script>

<style scoped>
/* Header gradient */
.bg-gradient-to-r {
  background: linear-gradient(to right, #0d9488, #0891b2);
}

/* Status Filter Buttons */
.status-filter-active {
  background-color: #0d9488;
  color: white;
  border-color: #0d9488;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}

.status-filter-inactive {
  color: #4b5563;
  border-color: #e5e7eb;
}

.status-filter-inactive:hover {
  border-color: #5eead4;
}

/* Status Chips */
.status-chip-pending {
  background-color: #fffbeb;
  color: #d97706;
  border-color: #fde68a;
}

.status-chip-approved {
  background-color: #ecfdf5;
  color: #059669;
  border-color: #a7f3d0;
}

.status-chip-rejected {
  background-color: #fff1f2;
  color: #e11d48;
  border-color: #fecdd3;
}

.status-chip-paid {
  background-color: #eef2ff;
  color: #4f46e5;
  border-color: #c7d2fe;
}

/* Status Dots */
.status-dot-pending {
  background-color: #fbbf24;
}

.status-dot-approved {
  background-color: #34d399;
}

.status-dot-rejected {
  background-color: #fb7185;
}

.status-dot-paid {
  background-color: #818cf8;
}

/* Status Border */
.status-border-pending {
  border-left: 4px solid #fcd34d;
}

.status-border-approved {
  border-left: 4px solid #6ee7b7;
}

.status-border-rejected {
  border-left: 4px solid #fda4af;
}

.status-border-paid {
  border-left: 4px solid #a5b4fc;
}

/* Status Evidence Needed (amber/orange) */
.status-chip-evidence {
  background-color: #fffbeb;
  color: #92400e;
  border-color: #fcd34d;
}

.status-dot-evidence {
  background-color: #f59e0b;
}

.status-border-evidence {
  border-left: 4px solid #fbbf24;
}

/* Info Card */
.info-card {
  padding: 0.75rem;
  border-radius: 0.75rem;
  background-color: #f0fdfa;
  border: 1px solid #99f6e4;
}

/* Province Badge */
.province-badge {
  padding: 0.25rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #0f766e;
  background-color: #ccfbf1;
  border-radius: 9999px;
}
</style>
